import api from '../services/api';
import { queryKeys } from './keys';

/**
 * Fetch a single item's full detail through the shared query cache, so a
 * detail already fetched by one call site (item click, processing
 * completion, a related-item link) is reused by the others instead of
 * re-fetched. Call sites: Gallery.jsx (item click, processing completion),
 * CollectionDetail.jsx (item click).
 */
export function fetchItemDetail(queryClient, userId, itemId) {
  return queryClient.fetchQuery({
    queryKey: queryKeys.item(userId, itemId),
    queryFn: () => api.getItem(itemId),
  });
}
